export const modalUtil = () => {

  // モーダル表示処理
  const showModal = (modalId) => {
    const modalEl = document.getElementById(modalId);
    if (!modalEl) return;
    const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
    modal.show();
  }

  // モーダル閉じる
  const hideModal = (modalId) => {
    // フォーカス外す（aria-hidden対策）
    if (document.activeElement) {
      document.activeElement.blur();
    }

    const modalEl = document.getElementById(modalId);
    if (!modalEl) return;

    const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
    modal.hide();
  }

  // モーダル切り替え処理
  const switchModal = (beforeModalId, afterModalId) => {
    const beforeModalEl = document.getElementById(beforeModalId);
    const beforeModal = bootstrap.Modal.getOrCreateInstance(beforeModalEl);
    
    // beforeModalが既に非表示かどうかチェック
    const isBeforeModalHidden = !beforeModalEl.classList.contains('show');
    
    if (isBeforeModalHidden) {
      // 既に非表示の場合は即座にafterModalを表示
      const afterModalEl = document.getElementById(afterModalId);
      const afterModal = bootstrap.Modal.getOrCreateInstance(afterModalEl);
      afterModal.show();
    } else {
      // 表示中の場合は、非表示になってからafterModalを表示
      const handleHidden = () => {
        const afterModalEl = document.getElementById(afterModalId);
        const afterModal = bootstrap.Modal.getOrCreateInstance(afterModalEl);
        afterModal.show();
        // イベントリスナーを削除
        beforeModalEl.removeEventListener('hidden.bs.modal', handleHidden);
      };
      
      beforeModalEl.addEventListener('hidden.bs.modal', handleHidden);
      // フォーカスを外す
      if (document.activeElement) document.activeElement.blur();
      beforeModal.hide();
    }
  }

  // 現在表示されているモーダルのIDを取得
  const getCurrentModalId = () => {
    const activeModal = document.querySelector('.modal.show');
    return activeModal ? activeModal.id : null;
  }

  // beforeModalIdを自動取得するモーダル切り替え処理
  const switchFromCurrentModal = (afterModalId) => {
    const currentModalId = getCurrentModalId();
    if (currentModalId) {
      switchModal(currentModalId, afterModalId);
    } else {
      // 現在表示されているモーダルがない場合は直接表示
      showModal(afterModalId);
    }
  }

  return {
    showModal,
    hideModal,
    switchFromCurrentModal
  }

}